import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithLogout } from 'helpers/generalHelper'

export const baseApi = createApi({
  reducerPath: 'baseApi',
  tagTypes: [
    'User',
    'Order',
    'OrderHistory',
    'Patient',
    'Company',
    'Office',
    'OfficeList',
    'OrderCounts',
    'OrderList',
    'Physicians',
    'PhysicianSettings',
    'FollowUpProviders',
    'PhysicianGroupOffices',
    'Messages',
    'Notes',
    'IncomingDocument',
    'LabPayer',
    'LabPayerList',
    'PayerChargeRules',
    'PayerHistory',
    'LabDmePayers',
    'DeviceBrands',
    'Devices',
    'Tickets',
    'OneShipCounts',
    'DailyCounts',
    'Bulletin',
    'Tag',
    'BillingProcedures',
    'AutomatedMessagesStatus',
    'BillingEra',
    'BillingEraTransactions',
    'NeedsWork',
    'BillingTransactionClaims',
    'EraPostingPlan',
    'EraExceptionQueue',
    'BillingPatientPayments',
    'BillingCharges',
    'BillingNotes',
    'BillingAttachments',
    'BillingDenials',
    'PatientStatements',
    'PendingPatientStatements',
    'PaperStatements',
    'PaymentReceipts',
    'ExternalApiCredential',
    'RetellOutboundSettings',
    'BillingSettings',
    'PlatformSettings',
    'CallHistory',
    'CatalogItem',
    'AccessPolicyAssignment',
    'ReaderAppVersions',
    'DeviceComplaints',
  ],
  baseQuery: baseQueryWithLogout,
  endpoints: () => ({}),
})
